import { BOARD_SIZE } from "./state";
export const rowColToIndex = (row, col) => row * BOARD_SIZE + col;
export const indexToRowCol = (index) => ({
    row: Math.floor(index / BOARD_SIZE),
    column: index % BOARD_SIZE,
});
